import { css } from 'styled-components';
import { breakpoints } from './breakpoints';
import { fontSizes } from './textSize';
const baseHeadingStyle = css `
  font-weight: 500;
  margin-bottom: 0.5rem;
  margin-top: 0;
`;
export const h1 = css `
  ${baseHeadingStyle}
  font-size: ${fontSizes.xl};
  line-height: 1.25;
  @media (min-width: ${breakpoints.md}px) {
    font-size: 2.75rem;
    line-height: 1.18181818;
  }
  @media (min-width: ${breakpoints.lg}px) {
    font-size: 3rem;
    line-height: 1.25;
  }
`;
export const h2 = css `
  ${baseHeadingStyle}
  font-size: ${fontSizes.lg};
  line-height: 1.33333333;
  @media (min-width: ${breakpoints.md}px) {
    font-size: ${fontSizes.xxl};
    line-height: 1.33333333;
  }
`;
export const h3 = css `
  ${baseHeadingStyle}
  font-size: ${fontSizes.md};
  line-height: 1.2;
  @media (min-width: ${breakpoints.md}px) {
    font-size: ${fontSizes.lg};
    line-height: 1.33333333;
  }
`;
export const h4 = css `
  ${baseHeadingStyle}
  font-size: ${fontSizes.sm};
  line-height: 1.25;
  @media (min-width: ${breakpoints.md}px) {
    font-size: ${fontSizes.md};
    line-height: 1.2;
  }
`;
export const h5 = css `
  ${baseHeadingStyle}
  font-size: ${fontSizes.sm};
  line-height: 1.25;
  text-transform: uppercase;
`;
export const h6 = css `
  font-size: ${fontSizes.sm};
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 0.5rem;
  margin-top: 0;
`;
//# sourceMappingURL=headings.js.map